import { useMemo } from 'react'
import { useCliLibraryFilters } from '../../api/react-query'
import {
  CliLibraryFilter,
  LibraryFilterType
} from '../../helpers/libraries-interfaces'
import { AggregationFilter } from '../filters/types'

interface UseCliFiltersArgs {
  organizationID: string
  applicationID?: string
  searchParam?: string // string with field and value and equals
  quickFilterParam?: string // quickFilter value
  filterParams?: string // string with ampersands between each field and value
}
export const useFilters = ({
  organizationID,
  applicationID,
  searchParam,
  quickFilterParam,
  filterParams
}: UseCliFiltersArgs) => {
  const cliFilters = useCliLibraryFilters(
    organizationID,
    true,
    applicationID,
    searchParam,
    quickFilterParam,
    filterParams
  )
  const isLoadingFilters = cliFilters.some((result) => result.isLoading)

  const libraryFiltersCli = useMemo((): AggregationFilter[] => {
    // split out and remove the QuickFilter from filters
    if (cliFilters) {
      return cliFilters
        .filter((result) => {
          return (
            !result.isLoading &&
            !result.isError &&
            result.data?.filterType !== LibraryFilterType.QuickFilter
          )
        })
        .map((filter: any) => {
          return {
            key: filter.data.filterType,
            label: filter.data.filterType,
            children: filter.data.filters?.map(
              (childFilter: CliLibraryFilter) => {
                return {
                  key: `${filter.data.filterType}.${childFilter.label}`,
                  label: childFilter.label,
                  parentKey: filter.data.filterType,
                  children: [],
                  count: childFilter.count,
                  value: childFilter.label
                }
              }
            )
          }
        })
    }

    return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingFilters, cliFilters])

  const quickFilterOptions = cliFilters
    ? cliFilters.find(
        (result) => result.data?.filterType === LibraryFilterType.QuickFilter
      )?.data?.filters
    : []

  return {
    quickFilterOptions,
    isLoadingFilters,
    libraryFilters: libraryFiltersCli,
    results: libraryFiltersCli
  }
}
